import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const breadcrumbsTheme: Pick<Components<Theme>, 'MuiBreadcrumbs'> = {
  MuiBreadcrumbs: {
    styleOverrides: {
      li: {
        display: 'inline-flex',
      },
    },
  },
};
